import React, { useContext, useState, useEffect } from "react";
import { PageContext } from "./App";
import { navigationController } from "./utils/navigationControl";

// It renders the Shift page where user enters start and end times for the shift.
// The page contains date inupt fiels and an option to review a previous shift if the latest shift has finished.
const Shift = () => {
  const [pendingShiftEnd, setPendingShiftEnd] = useState("");

  const {
    setShiftPage,
    shiftStart,
    setShiftStart,
    shiftEnd,
    setShiftEnd,
    pendingShiftStart,
    setPendingShiftStart,
    shiftStillInProgress,
    setShiftStillInProgress,
    setShiftConfirmed,
    sendToSiteWise,
    sendToSiteWiseShift,
    now,
    nowISOString,
  } = useContext(PageContext);

  useEffect(() => {
    setShiftStillInProgress(true);

    // Prevent navigation back to sign-in from shift page
    navigationController.preventBackNavigation();
  }, []);

  return (
    <div className="message">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "32px",
        }}
      >
        <div className="title">Please Enter Shift Details</div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            maxWidth: "250px",
            width: "100%",
          }}
        >
          <label style={{ textAlign: "left" }}>
            Shift Start:
            <input
              type="datetime-local"
              className="datetime-input"
              style={{ marginTop: "6px" }}
              value={pendingShiftStart}
              onChange={(e) => setPendingShiftStart(e.target.value)}
              max={nowISOString}
              onBlur={(e) => {
                // it does checks when user clicks out of the input
                const value = new Date(e.target.value);
                if (value > new Date()) {
                  alert(
                    "You selected a future time. Please choose a valid past time."
                  );
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftStart(isoString);
                }

                if (value < new Date(shiftStart)) {
                  alert("The time is before the current shift");
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftStart(isoString);
                } else if (value < new Date(shiftEnd)) {
                  alert("The shift time is not finished yet");
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftStart(isoString);
                }
              }}
            />
          </label>

          <label
            style={{
              textAlign: "left",
              opacity: shiftStillInProgress ? 0.5 : 1,
            }}
          >
            Shift End:
            <input
              type="datetime-local"
              className="datetime-input"
              style={{ marginTop: "6px" }}
              value={pendingShiftEnd}
              onChange={(e) => setPendingShiftEnd(e.target.value)}
              disabled={shiftStillInProgress}
              max={nowISOString}
              onBlur={(e) => {
                // it does checks when user clicks out of the input
                const value = new Date(e.target.value);
                if (value > new Date()) {
                  alert(
                    "You selected a future time. Please choose a valid past time."
                  );
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftEnd(isoString);
                }

                if (value < new Date(shiftStart)) {
                  alert("The time is before the current shift");
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftEnd(isoString);
                } else if (value < new Date(shiftEnd)) {
                  alert("The shift time is not finished yet");
                  const offset = now.getTimezoneOffset();
                  const localDate = new Date(
                    now.getTime() - offset * 60 * 1000
                  );
                  const isoString = localDate.toISOString().slice(0, 16);

                  e.target.value = isoString;
                  setPendingShiftEnd(isoString);
                }
              }}
            />
          </label>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "1rem",
              color: "#3f3f3f",
            }}
          >
            <input
              type="checkbox"
              className="checkbox-custom"
              checked={shiftStillInProgress}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setShiftStillInProgress(isChecked);
              }}
            />
            Shift is still in progress
          </label>
        </div>

        <button
          onClick={async () => {
            if (
              pendingShiftStart &&
              (pendingShiftEnd || shiftStillInProgress)
            ) {
              const startDate = new Date(pendingShiftStart);
              const endDate = shiftStillInProgress
                ? new Date()
                : new Date(pendingShiftEnd);

              if (endDate < startDate) {
                alert("Shift end cannot be earlier than the shift start.");
                return;
              }

              if (startDate > now) {
                alert("Shift start cannot be in the future.");
                return;
              }

              if (endDate > now && !shiftStillInProgress) {
                alert("Shift end cannot be in the future.");
                return;
              }

              // just in case blur warnings didnt work

              if (startDate < new Date(shiftStart)) {
                alert("The new start time is before the current shift");
                return;
              } else if (startDate < new Date(shiftEnd)) {
                alert("The start time is during the previous shift");
                return;
              }
              if (endDate < new Date(shiftStart)) {
                alert("The new end time is before the current shift");
                return;
              } else if (endDate < new Date(shiftEnd)) {
                alert("The end time is during the previous shift");
                return;
              }

              setShiftConfirmed(true);

              const payload = {
                startShiftTime: pendingShiftStart.toString(),
              };

              if (!shiftStillInProgress) {
                payload.endShiftTime = pendingShiftEnd.toString();
                setShiftEnd(pendingShiftEnd);
              }

              // Sends shift values that are used in the App. This function is in App.js
              await sendToSiteWise(payload);

              const payload2 = {
                startShiftTime: pendingShiftStart,
              };

              if (!shiftStillInProgress) {
                payload2.endShiftTime = pendingShiftEnd;
                setShiftEnd(pendingShiftEnd);
              }

              // Sends shift values that are used in Power BI. This function is in App.js
              await sendToSiteWiseShift(payload2);

              setShiftStart(pendingShiftStart);
              setPendingShiftStart("");
              setPendingShiftEnd("");
              setShiftPage(false);
            } else {
              alert(
                "Please select shift both start and end times, or mark the shift as still in progress."
              );
            }
          }}
        >
          Submit Shift
        </button>

        <label style={{ textAlign: "left" }}>
          <strong>Latest Shift:</strong>
        </label>

        {shiftStart && shiftStart !== "test" && (
          <div>
            Shift Started:{" "}
            {new Date(shiftStart).toLocaleTimeString("en-AU", {
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })}
          </div>
        )}

        {shiftEnd &&
          !shiftEnd.includes("still in progress") &&
          !isNaN(new Date(shiftEnd).getTime()) && (
            <div>
              Shift Ended:{" "}
              {new Date(shiftEnd).toLocaleTimeString("en-AU", {
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </div>
          )}

        <button
          onClick={async () => {
            setShiftPage(false);
          }}
        >
          Review Shift
        </button>
      </div>
    </div>
  );
};

export default Shift;
